import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import VueSocialSharing from 'vue-social-sharing'
import { createI18n } from 'vue-i18n'
import en from './i18n/en_US';
import fr from './i18n/fr_FR';

const i18n = createI18n({
    locale: 'fr',
    fallbackLocale: 'fr',
    globalInjection: true,
    messages: {
        en: en,
        fr: fr,
    },
})
const urlSearchParams = new URLSearchParams(window.location.search);
const lang = urlSearchParams.get('lang');
if (lang && ['en', 'fr'].includes(lang)) {
    i18n.global.locale = lang;
}

createApp(App).use(VueSocialSharing).use(router).use(store).use(i18n).mount('#app')

